import { AdminNavItem } from '../types/admin';

export const adminNavigation: AdminNavItem[] = [
  {
    id: 'dashboard',
    label: 'Übersicht',
    icon: 'LayoutDashboard',
    path: '/admin',
    permission: 'permissions.read',
  },
  {
    id: 'access',
    label: 'Benutzer & Zugriff',
    icon: 'Users',
    path: '/admin/access',
    permission: 'users.read',
    children: [
      {
        id: 'users',
        label: 'Benutzer',
        icon: 'User',
        path: '/admin/access/users',
        permission: 'users.read',
      },
      {
        id: 'roles',
        label: 'Discord-Rollen',
        icon: 'Shield',
        path: '/admin/access/roles',
        permission: 'permissions.read',
      },
      {
        id: 'permissions',
        label: 'Berechtigungen',
        icon: 'Key',
        path: '/admin/access/permissions',
        permission: 'permissions.read',
      },
    ],
  },
  {
    id: 'organization',
    label: 'Organisation',
    icon: 'Building2',
    path: '/admin/organization',
    permission: 'settings.read',
    children: [
      {
        id: 'departments',
        label: 'Abteilungen',
        icon: 'Building2',
        path: '/admin/organization/departments',
        permission: 'departments.read',
      },
      {
        id: 'positions',
        label: 'Positionen',
        icon: 'Briefcase',
        path: '/admin/organization/positions',
        permission: 'positions.read',
      },
      {
        id: 'settings',
        label: 'Einstellungen',
        icon: 'Settings',
        path: '/admin/organization/settings',
        permission: 'settings.read',
      },
    ],
  },
  {
    id: 'security',
    label: 'Sicherheit',
    icon: 'ShieldCheck',
    path: '/admin/security',
    permission: 'audit.read',
    children: [
      {
        id: 'audit',
        label: 'Audit-Log',
        icon: 'History',
        path: '/admin/security/audit',
        permission: 'audit.read',
      },
      {
        id: 'sessions',
        label: 'Sitzungen',
        icon: 'UserCog',
        path: '/admin/security/sessions',
        permission: 'audit.read',
      },
    ],
  },
  {
    id: 'system',
    label: 'System',
    icon: 'Cpu',
    path: '/admin/system',
    permission: 'system.status',
    children: [
      {
        id: 'status',
        label: 'Systemstatus',
        icon: 'Activity',
        path: '/admin/system/status',
        permission: 'system.status',
      },
    ],
  },
];

export function filterAdminNavigationByPermissions(
  items: AdminNavItem[],
  permissions: string[]
): AdminNavItem[] {
  return items
    .map((item) => {
      if (item.children) {
        const filteredChildren = filterAdminNavigationByPermissions(item.children, permissions);
        if (filteredChildren.length > 0) {
          return { ...item, children: filteredChildren };
        }
        if (item.permission && permissions.includes(item.permission)) {
          return item;
        }
        return null;
      }

      if (item.permission && !permissions.includes(item.permission)) {
        return null;
      }

      return item;
    })
    .filter((item): item is AdminNavItem => item !== null);
}

export function getActiveAdminSection(pathname: string): string | null {
  for (const section of adminNavigation) {
    if (section.path && pathname === section.path) {
      return section.path;
    }
    if (section.children) {
      for (const child of section.children) {
        if (child.path && (pathname === child.path || pathname.startsWith(`${child.path}/`))) {
          return child.path;
        }
      }
    }
  }
  return null;
}